import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from './store';
import { associationsSelector, associationsLoadingSelector, associationsErrorSelector, moreAssociationsLoadingSelector, noMoreAssociationsSelector, randomSelector } from './selectores';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const createSelectorHook = <TState, TSelected>(selector: (state: TState) => TSelected) => () => useSelector(selector);

export const useAssociations = createSelectorHook(associationsSelector);
export const useMoreAssociationsLoading = createSelectorHook(moreAssociationsLoadingSelector);
export const useAssociationsError = createSelectorHook(associationsErrorSelector);
export const useNoMoreAssociations = createSelectorHook(noMoreAssociationsSelector);
export const useRandom = createSelectorHook(randomSelector);
export const useAssociationsLoading = createSelectorHook(associationsLoadingSelector);